import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import styles from './LastCheckTime.css';

const cx = classnames.bind(styles);

function LastCheckTime({
    className,
    label
}) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <div className={classes}>
            <Icon name='refreshCircle' />
            <span>Last check: {label}.</span>
        </div>
    )
};

LastCheckTime.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string.isRequired
};

LastCheckTime.defaultProps = {
    className: ''
};

export {
    LastCheckTime
};
